
import * as AddressVC from './AddressViewController';

export type IAddressViewControllerConfig = AddressVC.IAddressViewControllerConfig;

export default AddressVC.default;
